import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {Location} from "@angular/common";
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {Depot} from "../../../../shared/view-model/store-management/depot.type";
import {Router} from "@angular/router";
import {FileService} from "../../../../core/visbos-core/http/file.service";
import {MovingDirection, WizardComponent} from "ng2-archwizard/dist";
import {SessionActions} from "../../../../shared/actions";
import {DepotNeedsComponent} from "../../../../store-management/procurement/depot-needs/depot-needs.component";

@Component({
  selector: 'vb-touch-depot-needs-wizard',
  templateUrl: './touch-depot-needs-wizard.component.html',
  styleUrls: ['./touch-depot-needs-wizard.component.css']
})
export class TouchDepotNeedsWizardComponent extends AbstractVisbosComponent implements OnInit {

  MovingDirection;

  @ViewChild(WizardComponent)
  wizard: WizardComponent;

  @ViewChild(DepotNeedsComponent)
  itemsComponent: DepotNeedsComponent;

  currentStep: number;

  canExitDepotPageProxy = (direction: MovingDirection) => this.canExitDepotPage.apply(this, [direction]);
  canExitItemsPageProxy = (direction: MovingDirection) => this.canExitItemsPage.apply(this, [direction]);

  selectedDepot: Depot;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fileService: FileService,
              private loc: Location,
              private router: Router) {
    super(sessionActions, cd);
    this.MovingDirection = MovingDirection;
  }

  onStepChanged() {
    this.currentStep = this.wizard.model.getIndexOfStep(this.wizard.model.currentStep);
    this.cd.detectChanges();
  }

  onFinalStepEntered() {
    this.onStepChanged();
  }

  onExitDepotPage(direction: MovingDirection) {

  }

  onExitItemsPage(direction: MovingDirection) {
    if (direction == MovingDirection.Forwards) {
      this.onFillUpDepotClicked();
    }
  }

  onGoHomeClicked() {
    this.router.navigate(['/touch']);
  }

  onPrintDispatchListClicked() {
    this.itemsComponent.onGenerateDispatchListPdfClick()
      .then(res => {
        let data = this.fileService.base64toBlob(res.data.dispatchListPdf, 'application/pdf', 512);
        this.fileService.printFile(data);
      })
      .catch(err => this.sessionActions.throwError(err));
  }

  onFillUpDepotClicked() {
    this.onGoHomeClicked();
  }

  onDepotSelected(depot: Depot) {
    this.selectedDepot = depot;
  }

  canExitDepotPage(direction: MovingDirection): boolean {

    if (direction == MovingDirection.Forwards) {
      return this.selectedDepot != null;
    }

    return false;

  }

  canExitItemsPage(direction: MovingDirection): boolean {

    return true;
    /*if (direction == MovingDirection.Forwards) {
      return this.itemsComponent && this.itemsComponent.canSend();
    } else {
      return true;
    }*/

  }

}


// WEBPACK FOOTER //
// ./src/app/visbos-touch-client/ui/touch-depot-needs/touch-depot-needs-wizard/touch-depot-needs-wizard.component.ts